import styled from "styled-components";

export const Inner = styled.div`
	max-height: 100px;
	padding: 12px;
	border: 1px solid #e5e7eb;
	border-radius: 14px;
	display: flex;
	gap: 12px;
	align-items: center;
	background: #ffffff;
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
	transition: all 0.15s ease;

	&:hover {
		border-color: #c7d2fe;
		box-shadow: 0 4px 14px rgba(79, 70, 229, 0.08);
	}
`;

export const ImageWrap = styled.div`
	width: 54px;
	height: 54px;
	border-radius: 12px;
	background: #f8fafc;
	border: 1px solid #eef2f7;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	flex-shrink: 0;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-width: 0;
	flex: 1;
`;

export const Section = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	min-width: 0;
`;
